import script from "./joboffer-search.vue?vue&type=script&setup=true&lang=js"
export * from "./joboffer-search.vue?vue&type=script&setup=true&lang=js"

import "./joboffer-search.vue?vue&type=style&index=0&id=0e96a112&lang=scss"

const __exports__ = script;

export default __exports__